export const books = [
  {
    id: 1,
    title: "Triball Pens",
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSo2MtYgZvAZ0wcyWJjBVWr61ap6pcyaof7Bg&s",
    originalPrice: 30,
    salePrice: 30,
    rating: 5,
    price: "price_1AABBC",
    summary: "The writing pen is perfect for all writers, with a comfortable design and smooth-flowing ink.",
  },
  {
    id: 2,
    title: "Rubber Pens",
    url: "https://www.shopmania.al/uploads/products/meta/sICCddlVpr2LpQd2x9TLmkHmC8usrr5zjk6LO0aA.jpeg",
    originalPrice: 280,
    salePrice: 250,
    rating: 4.5,
    price: "price_1AABBD",
    summary: "The pen is ideal for everyday writing, offering a smooth ink flow and high durability.",
  },
  {
    id: 3,
    title: "Chalks",
    url: "https://cdn.images.fecom-media.com/FE00002918/images/G101380_100183-GLS-ART-P01.jpg",
    originalPrice: 120,
    salePrice: 100,
    rating: 4,
    price: "price_1AABBE",
    summary: "High-quality chalks, suitable for any black surface or any kind of drawing.",
  },
  {
    id: 4,
    title: "Canvas",
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOmRnTIc-07mtxL2vutzdDLARaN-VbR-vdsZrZZou7TLG6kvkhl5H8daj_s1h5LcV4viE&usqp=CAU",
    originalPrice: 800,
    salePrice: 700,
    rating: 5,
    price: "price_1AABBF",
    summary: "High-quality canvas for painters looking for a durable surface for their creations.",
  },
  {
    id: 5,
    title: "Painting set",
    url: "https://officesolution.al/444-large_default/primo-bojra-per-tekstil-6-ngjyra-me-25ml.jpg",
    originalPrice: 20.0,
    salePrice: null,
    rating: 5,
    price: "price_1AABBG",
    summary: "Set of paints in various colors, ideal for painters of all levels.",
  },
  {
    id: 6,
    title: "Coloring Pens",
    url: "https://www.ekanceleri.com/cdn/shop/products/Fibracolor-Colormaxi-Fiber-Pen-12set_All_790_1_dfb2dad8-727b-448f-a2c8-f269eb73b9be.jpg?v=1654105275",
    originalPrice: 550,
    salePrice: 500,
    rating: 4.5,
    price: "price_1AABBH",
    summary: "Bright markers, suitable for highlighting and clear notes.",
  },
  {
    id: 7,
    title: "File folders",
    url: "https://www.shutterstock.com/image-photo/colorful-file-folders-isolated-on-260nw-376011874.jpg",
    originalPrice: 500,
    salePrice: 400,
    rating: 4,
    price: "price_1AABBI",
    summary: "Durable folders for storing and organizing important documents.",
  },
  {
    id: 8,
    title: "Cartolandia",
    url: "https://www.megateksa.com/media/catalog/product/cache/f479fffe34b916c2b3283e2d283a0c1e/7/8/780502_1.jpg",
    originalPrice: 50,
    salePrice: 40,
    rating: 4.5,
    price: "price_1AABBJ",
    summary: "Notebook with an attractive design and numerous pages for all your notes.",
  },
  {
    id: 9,
    title: "Adhesive Tape",
    url: "https://rimmed.al/wp-content/uploads/2023/05/skoc.webp",
    originalPrice: 40,
    salePrice: 30,
    rating: 4,
    price: "price_1AABBK",
    summary: "Durable tape for all writing and drawing needs.",
  },
  {
    id: 10,
    title: "Notebooks",
    url: "https://m.media-amazon.com/images/I/41-jCjvOEkL._AC_.jpg",
    originalPrice: 300,
    salePrice: 250,
    rating: 4.5,
    price: "price_1AABBL",
    summary: "Notebooks with ample pages, suitable for any type of notes or sketches.",
  },
  {
    id: 11,
    title: "Calculators",
    url: "https://static-01.daraz.com.np/p/f0c1c21445aa25c34f756327ff08e6eb.jpg",
    originalPrice: 250,
    salePrice: 200,
    rating: 5,
    price: "price_1AABBM",
    summary: "Accurate and easy-to-use calculator, suitable for solving mathematical problems.",
  },
  {
    id: 12,
    title: "USB 16GB",
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSOepHtCYAdQ0-2GqPy9f7ncXjhXPE6xWVEug&s",
    originalPrice: 1500,
    salePrice: 1200,
    rating: 5,
    price: "price_1AABBN",
    summary: "High-capacity USB for data storage and fast file transfer.",
  },
];
